import React from "react";

import { Icon } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";
import { DATA_CHECKS } from "containers/Home/reducer";

import styles from "./style.module.css";

export default class DataCleansing extends React.PureComponent {
  render() {
    const { id, blueprintId, selectedDataset } = this.props;

    // TODO: Move to reducer
    const warnings = selectedDataset
      ? Object.keys(selectedDataset.fields)
          .filter((f) => selectedDataset.warnings.filter((w) => w.scope === f).length > 0)
          .map((f) => ({
            field: f,
            warnings: selectedDataset.warnings.filter((w) => w.scope === f)
          }))
      : [];

    const dataChecks = DATA_CHECKS;
    const dataChecksPassed = dataChecks.length;

    return (
      <div className={styles.dataCleansing}>
        <AibleStep
          id={id}
          blueprintId={blueprintId}
          bId={"dataCleansing"}
          message={
            "Listed below are the automatic data cleansing steps that will be performed before your models are trained."
          }
          secondaryMessage={
            warnings.length === 0
              ? "No auto corrections found."
              : warnings.length === 1
                ? "One auto correction found."
                : warnings.length + " auto corrections found."
          }
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        />
        <div className={styles.cleansingRow}>
          <div className={styles.cleansingCol} style={{ maxWidth: "400px" }}>
            <div className={styles.datasetReviewHeader}>
              <span className={globalStyles.h1 + " " + globalStyles.bold}>{dataChecksPassed}</span>
              {"Data Validation Checks Completed"}
            </div>
            <div className={styles.datasetReviewContent}>
              {dataChecks.map((c, i) => (
                <div className={styles.datasetReviewRow} key={i}>
                  <div className={styles.datasetReviewCheck}>
                    <Icon type={"check"} size={10} />
                  </div>
                  <span>{c}</span>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.cleansingCol}>
            {warnings.length === 0 ? (
              <div className={styles.datasetReviewHeader}>
                <span className={globalStyles.h1 + " " + globalStyles.bold}>{"0"}</span>
                {"Auto corrections"}
              </div>
            ) : (
              <div className={styles.dCleanBody}>
                <div className={styles.datasetReviewHeader}>
                  <span className={globalStyles.h1 + " " + globalStyles.bold}>{warnings.length}</span>
                  {"Auto corrections applied"}
                </div>
                {warnings.map((w, i) => (
                  <div className={styles.dCleanField} key={i}>
                    <div className={styles.fHeader}>{w.field}</div>
                    {w.warnings.map((warning, index) => (
                      <div className={styles.fWarning} key={index}>
                        {warning.message}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
